module.exports = __webpack_public_path__ + "static/media/fa-white-arrow-right.e2ab4dea.png";